import React, { useContext } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getTotalCartQuantity } from "../../utils/shop";
import { EVENT_PROPERTIES_VALUES } from "../../types/Amplitude";
import { isNewCartEnabled } from "../../utils/general";
import { showCart } from "../../actions/ShopActions";

// Components
import IconButton from "../Atoms/IconButton";
import Image from "../Atoms/Image";
import { TrackingContext } from "../Utils/TrackingWrapper";

// Constants
import { IMGIX_BASE_PATH } from "../../utils/constants";

const renderCartQuantity = (totalQuantity) => {
  if (totalQuantity > 0) {
    return (
      <div className="cart_quantity_indicator">
        <span className="cart_quantity" data-testid="cart_quantity">
          {totalQuantity}
        </span>
      </div>
    );
  }

  return null;
};

export const onCartClick =
  ({
    openCart,
    trackOpenCart,
    trackViewCart,
    pageUrl,
    totalQuantity,
    lineItems,
    onClick,
  }) =>
  () => {
    trackOpenCart({
      pageUrl,
      totalQuantity,
      sectionName: EVENT_PROPERTIES_VALUES.Main_Header,
      action: EVENT_PROPERTIES_VALUES.Header_Cart_Icon_Clicked,
    });

    trackViewCart(lineItems);

    openCart();

    onClick();
  };

export const CartIcon = ({ openCart, checkout, onClick }) => {
  const {
    trackingActions: { trackOpenCart, trackViewCart },
    pageUrl,
  } = useContext(TrackingContext);
  const totalQuantity = getTotalCartQuantity(checkout.lineItems);

  if (isNewCartEnabled()) {
    return (
      <IconButton
        ariaLabel="Open Cart"
        className="open_cart_button"
        tabIndex={7}
        onClick={onCartClick({
          openCart,
          trackOpenCart,
          trackViewCart,
          pageUrl,
          totalQuantity,
          lineItems: checkout.lineItems,
          onClick,
        })}
      >
        <Image
          className="cart_icon"
          alt="Shopping Cart Icon"
          src={`${IMGIX_BASE_PATH}/shopping-cart-icon.svg`}
        />

        {renderCartQuantity(totalQuantity)}
      </IconButton>
    );
  }

  return null;
};

const mapStateToCartIconProps = (state) => {
  return {
    checkout: state.shop.checkout,
  };
};

const mapDispatchToCartIconProps = (dispatch) => {
  return {
    openCart: () => dispatch(showCart()),
  };
};

CartIcon.propTypes = {
  openCart: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  checkout: PropTypes.object.isRequired,
};

CartIcon.defaultProps = {
  onClick: () => {},
};

export default connect(
  mapStateToCartIconProps,
  mapDispatchToCartIconProps
)(CartIcon);
